import "./Layout.module.css";

export default function Layout(props){
    return(
        <main>{props.children}</main>
    );
}